<script>
  import { onMount } from "svelte";
  import { persist } from "../stores/store.js";

  const name = persist("name", "gorgeous");

  if ($name === "") {
    $name = "gorgeous";
  }

  let greeting = "Hello";
  let hour = localStorage.getItem("hour");

  if (hour < 12) {
    // morning
    greeting = "Good morning";
  } else if (hour < 18) {
    // afternoon
    greeting = "Good afternoon";
  } else if (hour < 22) {
    // evening
    greeting = "Good evening";
  } else {
    greeting = "Good night";
  }

  localStorage.setItem("greeting", JSON.stringify(greeting));

  let isInputFocus = false;
  let nameInput = null;

  $: isInputActive = !$name || isInputFocus;
  $: inputValue = $name || "";

  function nameInputSubmit() {
    if (inputValue) {
      $name = inputValue;
    } else if ($name) {
      inputValue = $name;
    } else if ($name === "") {
      $name = "gorgeous";
    }
    isInputFocus = false;

    document.removeEventListener("click", nameInputSubmit);
  }

  function handleKeyPress(event) {
    let input = document.querySelector(".name");
    if (event.charCode === 13) {
      nameInputSubmit();
      input.blur();
    } else if ($name === "") {
      $name = "gorgeous";
    }
  }

  function handleNameClick() {
    isInputFocus = true;
    nameInput.focus();
    nameInput.setSelectionRange(0, nameInput.value.length);
    document.addEventListener("click", nameInputSubmit);
  }

  function handleClickOff() {
    let input = document.querySelector(".name");
    if (isInputFocus === false && input.value === "") {
      input.value = "gorgeous";
    }
    input.style.width = input.value.length + "ch";
  }

  onMount(() => {
    let input = document.querySelector(".name");
    input.style.width = input.value.length + "ch";
  });
</script>

<style>
  div {
    display: flex;
    justify-content: center;
    position: relative;
    left: 1ch;
    filter: drop-shadow(-5px 5px 5px rgba(0, 0, 0, 0.3));
  }
  .name {
    padding: 0;
    border: none;
    background-color: transparent;
    color: white;
  }
</style>

<div>
  <h1>
    {greeting},
    <input
      class="name"
      on:blur={handleClickOff}
      on:keypress={handleKeyPress}
      bind:value={$name} />
  </h1>
</div>
